
<div class="folders" *transloco="let t; read: 'emails'">
  <div class="folder-select-button" (click)="onDrawerOpen()">
    <span>{{currentFolder}}</span>
    <i class="fa-solid fa-chevron-down"></i>
  </div>
  <app-drawer-component [list]="folderDrawerList" [drawerOpen]="showDrawer" [drawerTitle]="t('personalFolders')" (onClicked)="onDrawerItemClicked($event)" (drawerState)="onUpdateDrawerState($event)"></app-drawer-component>
</div>
